import {
  ajaxDelete,
  fetchJson,
  get,
  post,
  postDelete,
  postJson,
  userAction,
} from '@/util/helpers/ajax-helpers';
import { completed, loading, standardErrorHandler } from './helpers';
import {
  CATEGORY_DELETED,
  MODAL_DATA_LOADED,
  MODAL_SAVE_CLICKED,
  STAR_CLICKED,
  TABLE_ROWS_LOADED,
  VIEW_DELETED,
  VIEW_LOADED,
  VIEW_RETRYING,
  VIEW_STATUS,
} from './constants';
import ModalSaveLayers from '../components/modals/ModalSaveLayers';
import ModalShareAsHtml from '../components/modals/ModalShareAsHtml';
import ViewRef from '../util/ViewRef';
import { loadViewsData } from './actions-misc';

export function deleteView(view) {
  return (dispatch) => {
    dispatch(loading(VIEW_DELETED));
    ajaxDelete(`/views/${view.id()}`)
      .then((json) => {
        dispatch(completed(VIEW_DELETED, { deleted: view, json }));
        dispatch(loadViewsData()); // reload views data (needed, in particular, to update datasource.totalSavedViews)
        userAction('delete-saved-query', { view_id: view.id() });
      })
      .catch(standardErrorHandler(VIEW_DELETED, dispatch));
  };
}

export function shareAsHtml(view) {
  return (dispatch) => {
    dispatch(loading(MODAL_DATA_LOADED));
    fetchJson(`/view/${view.id()}/meta`)
      .then((json) => {
        dispatch(
          completed(MODAL_DATA_LOADED, { modal: ModalShareAsHtml, json }),
        );
      })
      .catch(standardErrorHandler(MODAL_DATA_LOADED, dispatch));
  };
}

export function editView(view) {
  return (dispatch) => {
    dispatch(loading(MODAL_DATA_LOADED));
    fetchJson(`/view/${view.id()}/meta`)
      .then((json) => {
        dispatch(
          completed(MODAL_DATA_LOADED, {
            modal: ModalSaveLayers,
            json,
            existing: view,
          }),
        );
      })
      .catch(standardErrorHandler(MODAL_DATA_LOADED, dispatch));
  };
}

export function starClicked(view, on) {
  return (dispatch) => {
    dispatch(loading(STAR_CLICKED, { view, on }));
    postJson(
      '/views/favourite',
      { _series: view.seriesId ?? view._series, _on: on },
      'PUT',
    )
      .then(() => {
        dispatch(completed(STAR_CLICKED, { view, on }));
      })
      .catch(standardErrorHandler(STAR_CLICKED, dispatch));
  };
}

export function removeCategory(category) {
  return (dispatch) => {
    postDelete('deleting category', '/categories', category).then(() => {
      // Force refresh of screen data
      dispatch(completed(CATEGORY_DELETED));
      dispatch(loadViewsData());
    });
  };
}

export function shareView(modal) {
  return (dispatch) => {
    dispatch(loading(MODAL_DATA_LOADED));
    fetchJson('/limits')
      .then((json) => {
        dispatch(completed(MODAL_DATA_LOADED, { json, modal }));
      })
      .catch(standardErrorHandler(MODAL_DATA_LOADED, dispatch));
  };
}

export function checkViewStatus(view) {
  return loading(VIEW_STATUS, { view });
}

export function updateViewStatus(json, view) {
  return completed(VIEW_STATUS, { json, view });
}

export function retryView(view) {
  return (dispatch) => {
    dispatch(loading(VIEW_RETRYING));
    postJson(`/views/${view.id()}/retry`)
      .then((json) => {
        dispatch(completed(VIEW_RETRYING, { json, view }));
        dispatch(checkViewStatus(view));
      })
      .catch(standardErrorHandler(VIEW_RETRYING, dispatch));
  };
}

export function importView(viewSeriesId, showChartingOptions = false) {
  return (dispatch, getState) => {
    const ds = getState().datasource;
    const imported = !ds.views.find((v) => viewSeriesId === v.series());
    dispatch(completed(MODAL_SAVE_CLICKED)); // hide modal
    dispatch(loading(VIEW_LOADED));
    get('opening your saved query', `/views/import/${viewSeriesId}`)
      .then((json) => {
        const viewRef = ViewRef.build(json._viewRef);
        dispatch(
          completed(VIEW_LOADED, {
            json,
            view: viewRef,
            imported,
            newWorld: ds.newWorld,
            showChartingOptions,
          }),
        );
        dispatch(checkViewStatus(viewRef));
        userAction('open-saved-query', { view_id: viewRef.id() });
      })
      .catch(standardErrorHandler(VIEW_LOADED, dispatch));
  };
}

export function fireViewWithFilters(
  viewSeriesId,
  appliedFilters,
  dashboardId,
  datasourcePath,
) {
  return (dispatch) => {
    dispatch(loading(TABLE_ROWS_LOADED));
    const body = {
      dashboardId,
      appliedFilters,
    };
    post('request new rows request', `/rows/${viewSeriesId}`, body)
      .then((json) => {
        userAction('open-in-query-builder-with-filters', {
          row_request_id: json.queryId,
        });
        window.open(`${datasourcePath}/queries/${json.queryId}`, '_blank');
      })
      .catch(standardErrorHandler(TABLE_ROWS_LOADED, dispatch));
  };
}

export function fireView(viewSeriesId) {
  return (dispatch) => {
    dispatch(loading(TABLE_ROWS_LOADED));
    get('opening saved query', `/views/import/${viewSeriesId}`)
      .then((json) => {
        userAction('open-in-query-builder', {
          view_id: json.rowRequestId,
        });
        const viewRef = ViewRef.build(json._viewRef);
        window.open(
          `${window.location.pathname}/saved-queries/${viewRef.series()}`,
        );
      })
      .catch(standardErrorHandler(TABLE_ROWS_LOADED, dispatch));
  };
}
